import React, { useEffect, useState } from "react";
import { getTestimonial } from "../Service/Api";

import SliderModule from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Slider = SliderModule.default || SliderModule;

function TestimonialVideo() {
  const [testimonials, setTestimonials] = useState([]);

  const placeholderCards = Array(4).fill(null);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const data = await getTestimonial();

        if (data && data.length > 0) {
          setTestimonials(data);
        }
      } catch (error) {
        console.error("Error fetching testimonials data:", error);
      }
    };

    fetchTestimonials();
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    pauseOnHover: true,

    responsive: [
      {
        breakpoint: 1499,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1299,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="testimonial-video-section">
      <div className="container-fluid">
        {testimonials && testimonials.length > 0 ? (
          <Slider {...settings}>
            {testimonials.map((item, index) => (
              <div className="testimonial-slide" key={item._id || index}>
                <div className="testimonial-card">
                  {/* Quote Icon */}
                  <div className="testimonial-icon">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/comma.png"
                      alt="Quote"
                    />
                  </div>

                  {/* Description */}
                  <div className="testimonial-description">
                    <p
                      dangerouslySetInnerHTML={{
                        __html: item.description || "",
                      }}
                    />
                  </div>
                </div>

                {/* User */}
                <div className="testimonial-user d-flex ">
                  <div className="testimonial-image">
                    <img
                      src="/Images/dummy-test.png"
                      alt={item.name || "Testimonial"}
                      className="img-fluid"
                    />

                    <span>
                      {item.name?.split(" ")[0]?.[0]?.toUpperCase()}
                      {item.name?.split(" ")[1]?.[0]?.toUpperCase()}
                    </span>
                  </div>

                  <div className="testimonial-info">
                    <span>{item.designation || "Parent"}</span>
                    <h5>{item.name || "Parent's Name"}</h5>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        ) : (
          <Slider {...settings}>
            {placeholderCards.map((_, index) => (
              <div className="testimonial-slide" key={index}>
                <div className="testimonial-card">
                  {/* Quote Icon */}
                  <div className="testimonial-icon">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/comma.png"
                      alt="Quote"
                    />
                  </div>

                  {/* Placeholder Description */}
                  <div className="testimonial-description">
                    <p>Stay Tuned for Parent Testimonials</p>
                  </div>
                </div>

                {/* Placeholder User */}
                <div className="testimonial-user d-flex ">
                  <div className="testimonial-image">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/dummy-test.png"
                      alt="Parent"
                      className="img-fluid"
                    />

                    <span>NA</span>
                  </div>

                  <div className="testimonial-info">
                    <span>Designation</span>
                    <h5>Parents' Name</h5>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        )}
      </div>
    </section>
  );
}

export default TestimonialVideo;
